export const formatPhonePT = (value: string): string =>
  (value || '')
    .replaceAll(/\D/g, '')
    .slice(0, 12)
    .replace(/(\d{3})(\d)/, '$1 $2')
    .replace(/(\d{3})(\d)/, '$1 $2')
    .replace(/(\d{3})(\d)/, '$1 $2')
